/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';
import BackButton from '../../common/BackButton';
import { determineLanguagePrefixPath } from '../../../../helpers/determineInternationalizationPath';

const styles = (theme) => ({
    trackOrderContainer: {
        display: 'flex',
        margin: '15px 0',
        '& button': {
            marginTop: '-5px',
            color: theme.palette.common?.black,
            fontSize: '12px !important',
            letterSpacing: '0.6px',
            textDecoration: 'underline',
        },
        '& svg': {
            fontSize: '22px',
            marginLeft: '15px',
        },
    },
});

const MobileOrderHeader = ({ classes }) => (
    <div className={classes.trackOrderContainer}>
        <BackButton url={determineLanguagePrefixPath('/track-order')} desktopOrderButton />
    </div>
);
MobileOrderHeader.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(MobileOrderHeader);
